// src/pages/Bulletjournals/index.jsx
import React, { useEffect, useState } from "react";
import CollectionPage from "./CollectionPage";
import { getBulletJournals, PRODUCTS_PER_PAGE } from "../data/bulletJournals";

export default function Bulletjournals() {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getBulletJournals()
      .then(setProducts)
      .catch(err => setError(err.message || "Failed to load products"));
  }, []);

  if (error) {
    return <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>;
  }
  if (!products) {
    return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>;
  }

  const config = {
    products,
    productsPerPage: PRODUCTS_PER_PAGE,
    basePath: "/bullet-journals",
    announcement: {
      headline: "New: Bullet Journals for every kind of creative planner!",
      subtext: "300+ designs to personalise • No code required",
    },
    hero: {
      title: "Bullet Journals",
      subtitle: "Dot-grid pages for creative, intentional planning",
     featuredIn: ["PREMIUM QUALITY", "TRUSTED CRAFTSMANSHIP", "PAN INDIA DELIVERY"],
      quote: "The dot grid is perfect and the paper quality is incredible — my favourite journal yet.",
      quoteLink: "#",
      rating: "4.7",
      ratingCount: "500+",
    },
  };

  return <CollectionPage config={config} />;
}